/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AddAssessableGroupRequest} from "../model/add-assessable-group-request";
import {AddAssessableItemRequest} from "../model/add-assessable-item-request";
import {AssessableItemGroup} from "../model/assessable-item-group";
import {Checklist} from "../model/checklist";
import {ChecklistItem} from "../model/checklist-item";
import {CreateByNameRequest} from "../model/create-by-name-request";
import {DeleteBatchChecklistRequest} from "../model/delete-batch-checklist-request";
import {DeleteChecklistRequest} from "../model/delete-checklist-request";
import {DuplicateChecklistRequest} from "../model/duplicate-checklist-request";
import {ListData} from "../model/list-data";
import {OperatorChecklist} from "../model/operator-checklist";
import {SuccessCreateResponse} from "../model/success-create-response";
import {SuccessResponse} from "../model/success-response";
import {UpdateAnswerOfOperatorChecklistRequest} from "../model/update-answer-of-operator-checklist-request";
import {UpdateAnswerRequest} from "../model/update-answer-request";
import {UpdateChecklistItemRequest} from "../model/update-checklist-item-request";
import {UpdateChecklistMetadataRequest} from "../model/update-checklist-metadata-request";
import {UpdateChecklistRequest} from "../model/update-checklist-request";
import {UserRecordingChecklist} from "../model/user-recording-checklist";
import {WebClientType} from "../model/web-client-type";

@Injectable({
    providedIn: "root",
})
export class SimChecklistService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public addAssessableGroup(request: AddAssessableGroupRequest) {
        return super.post<AssessableItemGroup<ChecklistItem>>(`/api/Checklist/AddAssessableGroup`, request);
    }

    public addAssessableItem(request: AddAssessableItemRequest) {
        return super.post<ChecklistItem>(`/api/Checklist/AddAssessableItem`, request);
    }

    public createChecklist(request: CreateByNameRequest) {
        return super.post<SuccessCreateResponse>(`/api/Checklist/CreateChecklist`, request);
    }

    public deleteBatchChecklist(request: DeleteBatchChecklistRequest) {
        return super.post<SuccessResponse>(`/api/Checklist/DeleteBatchChecklist`, request);
    }

    public deleteChecklist(request: DeleteChecklistRequest) {
        return super.post<SuccessResponse>(`/api/Checklist/DeleteChecklist`, request);
    }

    public downloadChecklist_Url(checklistId: string) {
        return super.getUrl(`/api/Checklist/DownloadChecklist`, {checklistId: checklistId});
    }

    public duplicateChecklist(request: DuplicateChecklistRequest) {
        return super.post<SuccessResponse>(`/api/Checklist/DuplicateChecklist`, request);
    }

    public getAllUserChecklistsFromScenarioRecording(scenarioRecordingId: string) {
        return super.get<{ [key: string]: UserRecordingChecklist[]; }>(`/api/Checklist/GetAllUserChecklistsFromScenarioRecording`, {scenarioRecordingId: scenarioRecordingId});
    }

    public getChecklistById(checklistId: string) {
        return super.get<Checklist>(`/api/Checklist/GetChecklistById`, {checklistId: checklistId});
    }

    public getChecklistByIds(ids: string[]) {
        return super.get<Checklist[]>(`/api/Checklist/GetChecklistByIds`, {ids: ids});
    }

    public getDefaultChecklist() {
        return super.get<Checklist>(`/api/Checklist/GetDefaultChecklist`, );
    }

    public getDefaultChecklists() {
        return super.get<ListData<Checklist>>(`/api/Checklist/GetDefaultChecklists`, );
    }

    public getFilteredChecklists(searchTerm: string = null, searchColumn: string = "name", sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<Checklist>>(`/api/Checklist/GetFilteredChecklists`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getOperatorChecklistsByIds(checklistIds: string[]) {
        return super.get<OperatorChecklist[]>(`/api/Checklist/GetOperatorChecklistsByIds`, {checklistIds: checklistIds});
    }

    public getUserChecklistsFromScenarioRecording(scenarioRecordingId: string, userId: string = null, clientType: WebClientType = null) {
        return super.get<UserRecordingChecklist[]>(`/api/Checklist/GetUserChecklistsFromScenarioRecording`, {scenarioRecordingId: scenarioRecordingId, userId: userId, clientType: clientType});
    }

    public listChecklists(searchTerm: string = null, sortColumn: string = "name", sortAscending: boolean = true, page: number = 0, pageSize: number = 2147483647) {
        return super.get<ListData<Checklist>>(`/api/Checklist/ListChecklists`, {searchTerm: searchTerm, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public updateAnswer(request: UpdateAnswerRequest) {
        return super.post<ChecklistItem>(`/api/Checklist/UpdateAnswer`, request);
    }

    public updateAnswerOfOperatorChecklist(request: UpdateAnswerOfOperatorChecklistRequest) {
        return super.post<ChecklistItem>(`/api/Checklist/UpdateAnswerOfOperatorChecklist`, request);
    }

    public updateChecklist(request: UpdateChecklistRequest) {
        return super.post<void>(`/api/Checklist/UpdateChecklist`, request);
    }

    public updateChecklistItem(request: UpdateChecklistItemRequest) {
        return super.post<ChecklistItem>(`/api/Checklist/UpdateChecklistItem`, request);
    }

    public updateChecklistMetadata(request: UpdateChecklistMetadataRequest) {
        return super.post<Checklist>(`/api/Checklist/UpdateChecklistMetadata`, request);
    }
}